module.exports = __webpack_public_path__ + "fonts/OpenSansCondensed-Bold.4c78904.ttf";